import React, { useEffect } from 'react';
import closeIcon from 'assets/icons/close.svg';

const Popup = ({
  title = "Title",
  children,
  handleYes,
  handleNo,
  textYes,
  textNo,
  setVisible,
  classPopup = "",
  onClose,
}) => {
  const closePopup = () => {
    if (onClose) {
      onClose();
    }
    if (setVisible) {
      setVisible(false);
    }
  };
  const isHTMLTextNo = /<\/?[a-z][\s\S]*>/i.test(textNo);
  const isHTMLTextYes = /<\/?[a-z][\s\S]*>/i.test(textYes);
  return (
    <div className={`popup-overlay ${classPopup}`}>
      <div className="popup">
        <button className="mn-popup-close" onClick={closePopup}>
          <img src={closeIcon} alt="close" />
        </button>
        <div className="popup-header">
          <div className="popup-title">{title}</div>
        </div>
        <div className="popup-content">{children}</div>
        <div className="popup-buttons">
          {/* {textNo && (
            <button
              className="popup-button popup-button-no"
              onClick={handleNo ? handleNo : closePopup}
            >
              {textNo}
            </button>
          )} */}
          {textNo && (
            isHTMLTextNo ? (
              <button className="popup-button popup-button-no" onClick={handleNo ? handleNo : closePopup} dangerouslySetInnerHTML={{ __html: textNo }} />
            ) : (
              <button className="popup-button popup-button-no" onClick={handleNo ? handleNo : closePopup}>{textNo}</button>
            )
          )}
          {/* {textYes && (
            <button
              className="popup-button popup-button-yes"
              onClick={handleYes}
            >
              {textYes}
            </button>
          )} */}
          {textYes && (
            isHTMLTextYes ? (
              <button className="popup-button popup-button-yes" onClick={handleYes} dangerouslySetInnerHTML={{ __html: textYes }} />
            ) : (
              <button className="popup-button popup-button-yes" onClick={handleYes}>{textYes}</button>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Popup;
